var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3709 8.70711C37.7614 8.31658 37.7614 7.68342 37.3709 7.29289L31.007 0.928932C30.6164 0.538408 29.9833 0.538408 29.5928 0.928932C29.2022 1.31946 29.2022 1.95262 29.5928 2.34315L35.2496 8L29.5928 13.6569C29.2022 14.0474 29.2022 14.6805 29.5928 15.0711C29.9833 15.4616 30.6164 15.4616 31.007 15.0711L37.3709 8.70711ZM0.663818 9H36.6638V7H0.663818V9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRightArrow);
export default __webpack_public_path__ + "static/media/mobileRightArrow.06e125abdae9a81cd5366cc3100f0e0e.svg";
export { ForwardRef as ReactComponent };